
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { makeNameQuery } from '@/helpers/queryHelperFunctions';
import { cloneDeep, isEqual } from 'lodash-es';

import LIST_DIRECTORY from '@/apollo/directory/ListDirectorySimple.gql';

import DirectoryMixins from '@/mixins/directory/DirectoryMixins';
import Breadcrumbs from '@/components/breadcrumbs/BreadcrumbsNew.vue';
import ContractorCollectionFilters from '@/components/companyContractors/ContractorCollectionFiltersPending.vue';
import DefaultContentLayout from '@/components/scaffold/DefaultContentLayoutNew.vue';
import CardPagination from '@/components/card/PaginationNew.vue';
import EmptyListPlaceholder from '@/components/common/EmptyListPlaceholder.vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import InvitationSideBar from '@/components/companyContractors/invitationsidebarNew.vue';

import ActionPanel from '@/components/common/ActionsPanel.vue';
import Message from '@/data/notificationsMessages';
import { NOTIFICATION } from '@/entities/Events';

import {
	getFiltersDataFromQuery,
	joinQueryValues,
} from '@/helpers/router/prepareFiltersQuery';
import {
	getPaginationDataFromQuery,
	getPaginationQuery,
} from '@/helpers/router/preparePaginationQuery';

import paginationConfig from '@/data/paginationConfig';
import contractorsCollectionFiltersTemplate from '@/data/filtersTemplates/contractorsCollectionFiltersTemplate';

import UiButton from '@/components/button/ui-button.vue';
import PlusIcon from '@/components/icons/PlusIconNew.vue';
import RouteNames from '@/entities/RouteNames';
import Roles from '@/entities/Roles';
import PaginationConfig from '@/entities/PaginationConfig';
import ContractorsCollectionFiltersQuery from '@/entities/filters/ContractorsCollectionFiltersQuery';
import getStateQueryConditions from '@/helpers/locations/stateQueryConditions';
import ContractorTable from '@/components/contractors/ContractorTable.vue';
import ContractorInvite from '@/components/contractors/ContractorInviteNewPopUp.vue';
import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";
import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageMyFavorites.vue";
import {
	Company,
	Manager,
	User,
	Contractor,
	User_Profile_Bool_Exp,
	Contractor_Bool_Exp,
} from '@/generated/graphql';
import CardBodyItem from '@/components/card/CardBodyItem.vue';
import EmptyListImageManagers from '@/components/icons/emptyListImages/EmptyListImageApplications.vue';
import ManagerSearchFilters from '@/views/manage/ManagerSearchFiltersInvite.vue';
import ManagerListCard from '@/components/managers/ManagerListCard.vue';
import ManagerInvite from '@/components/managers/ManagerInvite.vue';

@Component({
	components: {
		DefaultContentLayout,
		CardPagination,
		EmptyListPlaceholder,
		EmptyListImageContractors,
		LoadingOverlay,
		Breadcrumbs,
		PlusIcon,
		UiButton,
		InvitationSideBar,
		ElementsSizeProvider,
		ActionPanel,
		ContractorTable,
		ContractorInvite,
		EmptyListImageManagers,
		CardBodyItem,
		ManagerSearchFilters,
		ManagerListCard,
		ManagerInvite,
		ContractorCollectionFilters,
	},
	apollo: {
		contractors: {
			query: LIST_DIRECTORY,
			variables() {
				return this.directoryFilter;
			},
			skip() {
				return this.skipQuery;
			},
			update(data) {
				this.paginationConfig.total = data.total.aggregate.count;
				this.paginationConfig.loadedCount = data.contractor.length;
				this.$emit(
					'contractorsTotalChanged',
					this.paginationConfig.total
				);
				return data.contractor;
			},
		},
	},
})
export default class CompanyContractorsDBNew extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Boolean, default: false })
	readonly favoriteContractors!: boolean;
	@Prop({ type: Boolean, default: false }) readonly canAddProject!: boolean;
	@Prop({ type: Boolean, default: false }) readonly managerDatabase!: boolean;

	areAllItemsSelected = false;
	showModal: boolean = false;
	data: {
		id: number;
		given_name: string;
		family_name: string;
		email: string;
		company: string;
		img: string;
	}[];

	handleDownload({ loadData, download }) {
		this.showModal = true;
	}

	contractors: Contractor[] | undefined = undefined;
	selectedContractor: Contractor[] = [];

	paginationConfig: PaginationConfig = { ...paginationConfig };

	directoryFilters: ContractorsCollectionFiltersQuery = cloneDeep(
		contractorsCollectionFiltersTemplate
	);

	containerClasses: string = 'h-full';

	headers = [
		{ text: 'Resource', value: 'given_name' },
		{ text: 'Email', value: 'email' },
	];

	selectedItems = [
		{
			id: 1,
			given_name: 'John',
			family_name: 'Doe',
			email: 'john.doe@example.com',
			company: 'Bell',
			img: 'https://randomuser.me/api/portraits',
		},
	];

	dummyData: object = [
		{
			id: 1,
			given_name: 'John',
			family_name: 'Doe',
			email: 'john.doe@example.com',
			company: 'Bell',
			img: 'https://randomuser.me/api/portraits',
		},
		{
			id: 2,
			given_name: 'Maxwell',
			family_name: 'Doe',
			email: 'maxwell.doe@example.com',
			company: 'Rogers',
			img: 'https://randomuser.me/api/portraits',
		},
	];

	handleSelectAll(event) {
		if (this.areAllItemsSelected) {
			this.selectedContractor = [];

			this.areAllItemsSelected = false;
		} else {
			this.selectedContractor = [...this.contractors];

			this.areAllItemsSelected = true;
		}
	}

	handleRowCheckboxChange(manager) {
		const index = this.selectedContractor.findIndex(
			(item) => item.id === manager.id
		);

		if (index >= 0) {
			this.selectedContractor.splice(index, 1);
		} else {
			this.selectedContractor.push(manager);
		}
	}

	get isManagerDatabase(): boolean {
		return this.$route.name === RouteNames.MANAGER_CONTRACTOR_DATABASE;
	}

	get managerHasAccess(): boolean {
		return this.isManagerDatabase || this.favoriteContractors;
	}

	get empty(): boolean {
		if (!this.contractors) {
			return false;
		}
		return this.contractors.length === 0;
	}

	get hasData(): boolean {
		return Boolean(this.contractors);
	}

	get invitationButtonShown(): boolean {
		return !this.favoriteContractors && this.filtersEmpty;
	}

	get filtersEmpty(): boolean {
		return isEqual(
			this.directoryFilters,
			contractorsCollectionFiltersTemplate
		);
	}


  get emptyListPlaceholder(): string {
		if(this.filtersEmpty){
			return "Internal profiles that are pending formal invites will appear here";
	}

	if(!this.filtersEmpty){
	return "Nothing matches the query";
	}
  }
	get loading(): boolean {
		return this.$apollo.queries.contractors.loading;
	}

	get isManager(): boolean {
		return this.currentUser.role === Roles.MANAGER;
	}

	get currentUserManagerId(): string | undefined {
		return this.currentUser?.role === Roles.MANAGER
			? this.currentUser.manager?.id
			: undefined;
	}

	get isResourcesPage(): boolean {
		return this.$route.path.includes('/company_database');
	}

	get directoryFilter(): any {
		const { page, limit } = this.paginationConfig;

		const {
			countries,
			states,
			cities,
			titles,
			skills,
			managers,
			projects,
			name,
			available,
			minRate,
			maxRate,
		} = this.directoryFilters;

		const nextOffset = page * limit - limit;
		const filterConditions: Contractor_Bool_Exp[] = [
			{
				approved: { _eq: true },
				deleted: { _eq: false },
				_or: [
					{
						user: {
							pending_invite: {
								_eq: true,
							},
						},
					},
					{
						user: {
							pending_invite: {
								_eq: true,
							},
						},
					},
				],
			},
		];

		if (this.favoriteContractors) {
			const managerConditions = !this.currentUserManagerId
				? {}
				: {
						managers: {
							_and: [
								{
									manager: {
										id: {
											_eq: this.currentUserManagerId,
										},
									},
								},
								{
									approved: {
										_eq: true,
									},
								},
							],
						},
				  };

			filterConditions.push({
				_and: [
					{
						user: {
							favorited_by_users: {
								favorited_by_id: {
									_eq: this.currentUser.id,
								},
							},
						},
					},
					managerConditions,
				],
			});
		}

		if (this.isManager && this.isManagerDatabase) {
			const managerId = this.currentUser.manager!.id;

			filterConditions.push({
				managers: {
					_and: [
						{ manager_id: { _eq: managerId } },
						{ approved: { _eq: true } },
					],
				},
			});
		}

		if (name) {
			filterConditions.push(makeNameQuery(name, ['user']));
		}

		if (countries.length) {
			filterConditions.push({
				user: {
					profile: {
						country: { _in: countries },
					},
				},
			});
		}

		if (states.length) {
			filterConditions.push({
				user: {
					profile: {
						state: getStateQueryConditions({ countries, states }),
					},
				},
			});
		}

		if (cities.length) {
			filterConditions.push({
				user: {
					profile: {
						city: { _in: cities },
					},
				},
			});
		}

		if (available !== 'all') {
			filterConditions.push({
				user: {
					available: { _eq: available === 'yes' },
				},
			});
		}

		if (titles.length) {
			filterConditions.push({
				user: {
					profile: {
						job_title: { _in: titles },
					},
				},
			});
		}

		if (skills.length) {
			filterConditions.push({
				user: {
					profile: {
						skills: {
							skill_id: { _in: skills },
						},
					},
				},
			});
		}

		if (managers.length) {
			filterConditions.push({
				managers: {
					_and: [
						{ manager_id: { _in: managers } },
						{ approved: { _eq: true } },
					],
				},
			});
		}

		if (projects.length) {
			filterConditions.push({
				project_activities: {
					project: {
						id: { _in: projects },
					},
				},
			});
		}

		if (minRate || maxRate) {
			const minConditions: User_Profile_Bool_Exp[] = [];
			const maxConditions: User_Profile_Bool_Exp[] = [];

			if (minRate) {
				minConditions.push({ min_rate: { _gte: minRate } });
				maxConditions.push({ max_rate: { _gte: minRate } });
			}
			if (maxRate) {
				minConditions.push({ min_rate: { _lte: maxRate } });
				maxConditions.push({ max_rate: { _lte: maxRate } });
			}

			if (minConditions.length && maxConditions.length) {
				filterConditions.push({
					user: {
						profile: {
							_or: [
								{ _and: minConditions },
								{ _and: maxConditions },
							],
						},
					},
				});
			}
		}

		return {
			offset: nextOffset,
			limit: limit,
			where: {
				_and: filterConditions,
			},
			id: this.currentUser.id,
		};
	}

	get queryPropsToWatch(): string {
		return JSON.stringify([this.directoryFilters, this.paginationConfig]);
	}

	get queryParams(): {
		filters: ContractorsCollectionFiltersQuery;
		pagination: PaginationConfig;
	} {
		const query = this.$route.query;
		const { min_rate: minRate, max_rate: maxRate, ...queryParams } = query;

		const queryData = {
			minRate,
			maxRate,
			...queryParams,
		};

		return {
			filters: getFiltersDataFromQuery<ContractorsCollectionFiltersQuery>(
				contractorsCollectionFiltersTemplate,
				queryData
			),
			pagination: {
				...this.paginationConfig,
				...getPaginationDataFromQuery(query),
			},
		};
	}

	get isChosenPageEmpty(): boolean {
		const collectionEmpty = this.contractors?.length === 0;
		const notFirstPage = this.paginationConfig.page !== 1;

		return !this.loading && collectionEmpty && notFirstPage;
	}

	@Watch('queryPropsToWatch')
	updateQuery(): void {
		if (this.isChosenPageEmpty) {
			return this.showFirstPage();
		}

		const paginationQuery = getPaginationQuery(this.paginationConfig);

		const { minRate, maxRate, ...filtersData } = this.directoryFilters;

		const query = joinQueryValues({
			...paginationQuery,
			...filtersData,
			min_rate: minRate,
			max_rate: maxRate,
		});

		if (isEqual(query, this.$route.query)) {
			return;
		}

		this.$router.push({ query }).catch(() => {});
	}

	@Watch('$route.query', { immediate: true })
	onQueryChange(): void {
		const { filters, pagination } = this.queryParams;

		this.directoryFilters = filters;
		this.paginationConfig = pagination;
	}

	mounted(): void {
		if (!!this.company) {
			this.$apollo.queries.contractors.skip = false;
		}
	}

	showFirstPage(): void {
		this.paginationConfig = {
			...this.paginationConfig,
			page: paginationConfig.page,
		};
	}

	managerAccessApproved(contractor: Contractor): boolean {
		return Boolean(contractor?.user.contracts[0]?.managers[0]?.approved);
	}

	updateFilters(updatedFilters: ContractorsCollectionFiltersQuery): void {
		const dataEqual = isEqual(this.directoryFilters, updatedFilters);

		if (dataEqual) {
			return;
		}

		const { minRate, maxRate, ...filtersData } = updatedFilters;

		const query = joinQueryValues({
			...filtersData,
			min_rate: minRate,
			max_rate: maxRate,
		});

		this.$router.push({ query }).catch(() => {});
	}

	resetFilters(): void {
		if (
			isEqual(this.directoryFilters, contractorsCollectionFiltersTemplate)
		) {
			return;
		}

		this.directoryFilters = cloneDeep(contractorsCollectionFiltersTemplate);
		this.paginationConfig = { ...paginationConfig };
	}

	message(userId: string): void {
		this.$router.push({
			name: RouteNames.INBOX,
			query: {
				recipientUserId: userId,
			},
		});
	}

	handleRefetch(): void {
		this.$apollo.queries.contractors.refetch();
		this.$emit('refetchRequests');
		this.$emit('refetchRequestsContractorsNumber');
	}

	prepareFilters(filterValues: Record<string, any>): void {
		this.directoryFilters = {
			...this.directoryFilters,
			...filterValues,
		};
	}
}
